'use client'

import { useEffect, useMemo } from 'react'

import { useExperimentsContext } from '../../experiments/components/ExperimentsContext'
import { useGetExperiment } from '../../experiments/hooks'
import { type RecommendationServiceType } from '../config'

import { recommendationExperimentServiceIdConfig } from './recommendationExperimentServiceIdConfig'
import { recommendationResolveExperimentServiceId } from './recommendationResolveExperimentServiceId'

export const useRecommendationExperimentServiceId = (
  serviceId?: RecommendationServiceType,
): string | undefined => {
  const serviceIdConfig = serviceId
    ? recommendationExperimentServiceIdConfig[serviceId]
    : undefined
  const experiment = useGetExperiment(serviceIdConfig?.experimentName)
  const { addExperimentKeysForActivation } = useExperimentsContext()

  useEffect(() => {
    if (!serviceIdConfig || !experiment.isEnabled) {
      return
    }

    addExperimentKeysForActivation(serviceIdConfig.experimentName)
  }, [addExperimentKeysForActivation, serviceIdConfig, experiment.isEnabled])

  return useMemo(() => {
    if (!serviceId) {
      return undefined
    }

    return recommendationResolveExperimentServiceId({
      experiment,
      serviceId,
      serviceIdConfig,
    })
  }, [serviceIdConfig, experiment, serviceId])
}
